import { createSourcedAction } from '@ces/sourced-action';
import { props } from '@ngrx/store';
import { BTaxAccount } from 'egov-api';

export const addBTaxAccountData = createSourcedAction('Add BTax Account data', props<{ accountsData: BTaxAccount[] }>());
